/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DraftArticlesQueryVariables = {||};
export type DraftArticlesQueryResponse = {|
  +whoAmI: ?{|
    +groups: $ReadOnlyArray<{|
      +name: string
    |}>
  |},
  +draftArticles: ?$ReadOnlyArray<?{|
    +id: string,
    +title: string,
    +slug: ?string,
    +endpoint: ?string,
    +imageUrl: ?string,
    +author: {|
      +fullName: ?string
    |},
    +createdOn: ?string,
  |}>,
  +adminDraftArticles: ?$ReadOnlyArray<?{|
    +id: string,
    +title: string,
    +slug: ?string,
    +endpoint: ?string,
    +imageUrl: ?string,
    +author: {|
      +fullName: ?string
    |},
    +createdOn: ?string,
  |}>,
|};
export type DraftArticlesQuery = {|
  variables: DraftArticlesQueryVariables,
  response: DraftArticlesQueryResponse,
|};
*/


/*
query DraftArticlesQuery {
  whoAmI {
    groups {
      name
    }
    id
  }
  draftArticles {
    id
    title
    slug
    endpoint
    imageUrl
    author {
      fullName
      id
    }
    createdOn
  }
  adminDraftArticles {
    id
    title
    slug
    endpoint
    imageUrl
    author {
      fullName
      id
    }
    createdOn
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "GroupType",
  "kind": "LinkedField",
  "name": "groups",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endpoint",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdOn",
  "storageKey": null
},
v8 = [
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "UserType",
    "kind": "LinkedField",
    "name": "author",
    "plural": false,
    "selections": [
      (v6/*: any*/)
    ],
    "storageKey": null
  },
  (v7/*: any*/)
],
v9 = [
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "UserType",
    "kind": "LinkedField",
    "name": "author",
    "plural": false,
    "selections": [
      (v6/*: any*/),
      (v1/*: any*/)
    ],
    "storageKey": null
  },
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DraftArticlesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "whoAmI",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ArticleType",
        "kind": "LinkedField",
        "name": "draftArticles",
        "plural": true,
        "selections": (v8/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ArticleType",
        "kind": "LinkedField",
        "name": "adminDraftArticles",
        "plural": true,
        "selections": (v8/*: any*/),
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DraftArticlesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "whoAmI",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ArticleType",
        "kind": "LinkedField",
        "name": "draftArticles",
        "plural": true,
        "selections": (v9/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ArticleType",
        "kind": "LinkedField",
        "name": "adminDraftArticles",
        "plural": true,
        "selections": (v9/*: any*/),
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b37b44a6f08bd0b5ea9ff73f9be83131",
    "id": null,
    "metadata": {},
    "name": "DraftArticlesQuery",
    "operationKind": "query",
    "text": "query DraftArticlesQuery {\n  whoAmI {\n    groups {\n      name\n    }\n    id\n  }\n  draftArticles {\n    id\n    title\n    slug\n    endpoint\n    imageUrl\n    author {\n      fullName\n      id\n    }\n    createdOn\n  }\n  adminDraftArticles {\n    id\n    title\n    slug\n    endpoint\n    imageUrl\n    author {\n      fullName\n      id\n    }\n    createdOn\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ab771fa6404f55047dcc2c23c03c626b';

module.exports = node;
